import React from 'react';
import { connect } from 'react-redux';
import { HomeView } from '../../HomeView';
import { MelezeConfigPreview } from 'module/Model/MelezeConfig';
import { NotFound } from '../NotFound';
import { PageView } from '../../PageView';
import { PostView } from '../../PostView';
import { PreviewType, Route, RouteType } from 'module/Model/Routes';
import { RouterSelector } from 'module/Redux/Router';
import { RouterUtils } from 'module/Common';
import { State } from 'module/Redux';
// import posed, { PoseGroup } from 'react-pose';

// const PoseChild: React.SFC<{}> = posed.div({
//   enter: { opacity: 1 },
//   exit: { opacity: 0 },
// });

// const PoseGroupAny = PoseGroup as any;

type StateProps = {
  route: Route | null;
  isPreview: boolean;
  preview: MelezeConfigPreview;
};

const mapStateToProps = (s: State): StateProps => ({
  route: RouterSelector.selectMatchingRoute(s),
  isPreview: RouterSelector.isPreview(s),
  preview: RouterSelector.selectPreview(s),
});

type OwnProps = {
  adminBar: boolean;
  availableWidth: number;
};

type Props = StateProps & OwnProps;

const RouterComp: React.SFC<Props> = ({ route, isPreview, preview, adminBar, availableWidth }) => {
  const key = RouterUtils.extractKey(route);
  const child = (() => {
    if (isPreview) {
      if (preview === null) {
        return null;
      }
      if (preview.type === PreviewType.Page) {
        return <PageView key={key} previewData={preview.data} adminBar={adminBar} availableWidth={availableWidth} />;
      }
      if (preview.type === PreviewType.Post) {
        return <PostView key={key} previewData={preview.data} adminBar={adminBar} availableWidth={availableWidth} />;
      }
      return null;
    }
    if (route === null) {
      return <NotFound />;
    }
    switch (route.type) {
      case RouteType.Home:
      case RouteType.Category:
        return <HomeView key={key} categoryId={route.id} availableWidth={availableWidth} />;
      case RouteType.Page:
        return <PageView key={key} adminBar={adminBar} availableWidth={availableWidth} />;
      case RouteType.Post:
        return <PostView key={key} adminBar={adminBar} availableWidth={availableWidth} />;
      case RouteType.NotFound:
        return <NotFound key={key} />;
      default:
        return <div>Unhandled type: {route.type}</div>;
    }
  })();
  return child;
  // return (
  //   <PoseGroupAny>
  //     <PoseChild key={key}>{child}</PoseChild>
  //   </PoseGroupAny>
  // );
};

export const Router = connect(mapStateToProps)(RouterComp);



// WEBPACK FOOTER //
// ./src/module/View/Main/Router/Router.tsx